import React, {useEffect, useState} from 'react';
import {user_data} from "../../../../../../../../components/functions/usr";
import decade_days, {gmslar, season_month} from "../../../../../../../../components/sfr/maydon";
import axios from "axios";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import {header} from "../../../../../../../../components/api/Header";
import Info from "./Info";
import { getEnv } from "../../../../../../../../lib/env";

function Xisobot5(props) {
    const year = localStorage.getItem('sfr-hm-year')
    const user = user_data()
    const season = localStorage.getItem('sfr-hm-season')
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const crops1 = localStorage.getItem('sfr-hm-noveg-ekinids')
    const cropids = crops1?JSON.parse(crops1):[]
    const [swed, setSwed] = useState({})
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist?JSON.parse(ist):[]
    const [maydonlar, setMaydonlar] = useState({})
    const ekin = localStorage.getItem("sfr-hm-noveg-ekinlar")
    const ekinlar = ekin?JSON.parse(ekin):{}
    const sfrMaydon = localStorage.getItem("sfr-hm-noveg-maydon")
    const sfrMaydonlar = sfrMaydon?JSON.parse(sfrMaydon):{}
    const daysindek = decade_days(season,year)
    const may = localStorage.getItem("sfr-hm-noveg-maydon")
    const maydon = may?JSON.parse(may):[]
    const ste = localStorage.getItem("sfr-hm-ste")
    const sfrsanoat = ste?JSON.parse(ste):{}
    const [yonalishlar,setYonalishlar] = useState([])
    const [birlik,setBirlik] = useState(1000)
    useEffect(()=>{
        let gmss = []
        const fetchSwed = async (gmss,gmss2) => {
            const postData = {
                crops:cropids,
                gmss,
                maydonlar:gmss2
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/noveg_sugorish_meyyori2",
                postData,
                header(),
            )
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setSwed(res.data)
            }
        }
        const fetchYonalishlar = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/yonalishlar",header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setYonalishlar(res.data)
            }
        }
        const maydons = () => {
            let gidromodullar = []
            istemolchilar.map(i=>{
                if(i.gms){
                    i.gms.map(g=>{
                        if(!gidromodullar.includes(g)){
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydons()
        fetchYonalishlar()
        const gmss2 = gmslar(maydon,cropids)
        setMaydonlar(gmss2)
        if(gmss2)
            fetchSwed(gmss,gmss2)
    },[])
    const ff = (ist,fik) => {
        if(!ist.gms) return 0
        if(!ist.gms.length) return 0
        let res = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        for(let deks = 1; deks < 19; deks++){
            let bm = 0
            let jbm = 0
            Object.keys(ekinlar).map(e=>{
                let nm = 0
                let jnm = 0
                if(swed[e.slice(1)]){
                    ist.gms.map(gms2=>{
                        if(swed[e.slice(1)][gms2]){
                            let jm = maydonlar['g'+gms2]?maydonlar['g'+gms2][e]:0
                            let im = sfrMaydonlar['i'+ist.id]?sfrMaydonlar['i'+ist.id]['g'+gms2]?sfrMaydonlar['i'+ist.id]['g'+gms2][e]:0:0
                            let ds = swed[e.slice(1)][gms2][deks] * (1/0.0864/daysindek['d'+deks])
                            let jds = swed[e.slice(1)][gms2][deks]
                            nm = addFunc(nm,(bolFunc(im,jm)*ds))
                            jnm = addFunc(jnm,(bolFunc(im,jm)*jds))
                        }
                    })
                    bm = addFunc(bm,bolFunc(nm,fik))
                    jbm = addFunc(jbm,bolFunc(jnm,fik))

                }
            })
            res[deks-1] = bm > 0 ? bm : 0
            res[18] = addFunc(res[18],jbm > 0 ? jbm : 0)
        }
        return res
    }
    const getFik = (manba_id) => {
        if(manbalar.length){
            const km = manbalar.filter(m=>m.id == manba_id)
            return km[0]?km[0].fik?km[0].fik:1:1
        }
    }
    const xisobot = () => {
        let jami_sanoat = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
        if(manbalar.length){
            let obj = [];
            let jm = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
            let sug = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            let jami = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            let jamisugorish = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            manbalar.map((manba,i)=>{
                sug = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                jm = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                let istemolchi = istemolchilar.filter(istemolchi=>istemolchi.mid == manba.id)
                if(istemolchi.length){
                    istemolchi.map(ist => {
                        let ms = ff(ist,manba.fik)
                        if(ms.length){
                            ms.map((m,mi)=>{
                                sug[mi] = addFunc(sug[mi],m)
                                return null
                            })
                        }
                    })
                }
                let sanoat = sfrsanoat.filter(s=>s.manba == manba.id)
                for(let d = 1; d < 19 ; d++){
                    let wq = 0
                    if(sanoat.length){
                        sanoat.map(s=>{
                            let q = bolFunc(s['d'+d],manba.fik)
                            wq = addFunc(wq,q)
                        })
                    }
                    jami_sanoat[d-1] = addFunc(jami_sanoat[d-1],bolFunc(wq,birlik))
                    jami_sanoat[18] = addFunc(jami_sanoat[18],bolFunc(wq,(1/(0.0864/birlik)/daysindek['d'+d])))
                    let w = addFunc(wq,sug[d-1])
                    jm[d-1] = w
                    jm[18] = addFunc(jm[18],bolFunc(w,(1/0.0864/daysindek['d'+d])))
                }

                for(let de = 0; de < 19 ; de++){
                    jami[de] = addFunc(jami[de],bolFunc(jm[de],birlik))
                    jamisugorish[de] = addFunc(jamisugorish[de],bolFunc(sug[de],birlik))
                }
                obj.push(
                    <tr key={i+"n"}>
                        <td rowSpan={4}>{i + 1}</td>
                        <td className="text-start">{manba.name}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )
                obj.push(
                    <tr key={i+"j"}>
                        <th className="text-end pe-1">Jami</th>
                        {
                            jm.map((j,ji)=>{
                                return <th key={ji}>{fixIt((j / birlik),3)}</th>
                            })
                        }
                    </tr>

                )
                obj.push(
                    <tr key={i+"s"}>
                        <td className="text-end pe-1">Sh.j sug'orishga</td>
                        {
                            sug.map((s,si)=>{
                                return <td key={si}>{fixIt((s / birlik),3)}</td>
                            })
                        }
                    </tr>
                )
                obj.push(
                    <tr key={i+"ste"}>
                        <td className="text-end pe-1">STE (ptn)</td>
                        {
                            sug.map((s,si)=>{
                                return <td key={si}>{fixIt((jm[si] / birlik - sug[si] / birlik),3)}</td>
                            })
                        }
                    </tr>
                )
            })
            obj.push(
                <tr key='jamijami'>
                    <th colSpan={2} className="text-start">Jami {user.district} bo'yicha</th>
                    {
                        jami.map((ja,jai)=>{
                            return <th key={jai}>{fixIt(ja,3)}</th>
                        })
                    }
                </tr>

            )
            obj.push(
                <tr key="jamisug">
                    <th colSpan={2} className="text-start">Sh.j sug'orishga</th>
                    {
                        jamisugorish.map((js,jsi)=>{
                            return <th key={jsi}>{fixIt(js,3)}</th>
                        })
                    }
                </tr>
            )
            obj.push(
                <tr key="jamisanoat">
                    <th colSpan={2} className="text-center">Jami STE (ptn)</th>
                    {
                        jami_sanoat.map((js,jsi)=>{
                            return <th key={jsi}>{fixIt(js,3)}</th>
                        })
                    }
                </tr>
            )
            if(yonalishlar.length){
                yonalishlar.map(y=>{
                    let ky = sfrsanoat.filter(sf=>sf.yonalish==y.id)
                    let kyd = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                    if(ky.length){
                        ky.map(iky=>{
                            const fik = getFik(iky.manba)
                            for(let d = 1; d < 19; d++){
                                kyd[d-1] = addFunc(kyd[d-1],bolFunc(iky['d'+d],fik))
                                kyd[18] = addFunc(kyd[18],bolFunc(iky['d'+d],fik)*0.0864*daysindek['d'+d])
                            }
                        })
                    }
                    obj.push(
                        <tr key={y.id}>
                            <td colSpan={2} className="text-end">{y.yonalish}</td>
                            {
                                kyd.map((js,jsi)=>{
                                    return <td key={jsi}>{js?fixIt(bolFunc(js,birlik),3):''}</td>
                                })
                            }
                        </tr>
                    )
                })
            }
            return obj;
        }
    }

    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-borderless m-0">
                    <thead>
                    <tr>
                        <td><h4 className="text-center">Xisobot - №3</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 className="text-center px-5">{user.district}ning sug'orish manbalaridan {year}-{parseInt(year)+1} yilning nosug'orish davrida suv olish <br/> <span className="text-uppercase">JADVALI</span></h5>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-3">
                    <select className="form-select ms-auto" style={{maxWidth:"max-content"}} onChange={e=>{setBirlik(parseInt(e.target.value))}}>
                        <option value="1000">m<sup>3</sup>/sek</option>
                        <option value="1">l/sek</option>
                    </select>
                </div>
                <div className="flex-box xisobot-table">
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background:"#77adba",color:"#fff"}}>
                            <tr>
                                <th rowSpan={2}>No</th>
                                <th rowSpan={2}>Tuman irrigatsiya bo'limi</th>
                                {
                                    season_month(season).map((m,i)=>{
                                        return <th key={i} colSpan={3}>{m}</th>
                                    })
                                }
                                <th rowSpan={2}>Jami mln.m<sup>3</sup></th>
                            </tr>
                            <tr>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-2">
                <Info />
            </div>
        </div>
    );
}

export default Xisobot5;